import { RootState } from '../../../store'
import { HideShowOption } from '../../../models/Construction'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import BuildingElementMeasurements from './BuildingElementMeasurements'
import FreeMeasurements from './FreeMeasurements'
import { useEffect } from 'react'
import { SceneManager } from '../../../visualization/sceneManager'
import { createSelector } from '@reduxjs/toolkit'

const selectAreMeasurementsVisible = createSelector(
  [
    (state: RootState) => state.construction.hideShowOptions,
    (state: RootState) => state.construction.is3DViewActive,
    (state: RootState) => state.construction.is2DViewActive,
  ],
  (hideShowOptions, is3DViewActive, is2DViewActive) => {
    return Boolean(
      hideShowOptions[HideShowOption.MeasurementsVisibility] &&
        is3DViewActive &&
        !is2DViewActive,
    )
  },
)

const Measurements = () => {
  const areMeasurementsVisible = useSelector(selectAreMeasurementsVisible)

  useEffect(() => {
    return () => {
      const sceneManager = SceneManager.getInstance()
      sceneManager.isMeasurementsUIVisible = false
    }
  }, [])

  useEffect(() => {
    const sceneManager = SceneManager.getInstance()
    sceneManager.isMeasurementsUIVisible = areMeasurementsVisible
  }, [areMeasurementsVisible])

  return (
    <Box
      sx={{
        zIndex: '10 !important',
      }}
    >
      <BuildingElementMeasurements isVisible={areMeasurementsVisible} />

      <FreeMeasurements isVisible={areMeasurementsVisible} />
    </Box>
  )
}

export default Measurements
